import request from '../utils/request'

function login(data) {
  return request.post('/user/login', data)
}

function getCaptcha() {
  return request.get('/captchaImage')
}

function register(data) {
  return request.post('/user/register', data)
}

function fetchSupplies(pageIndex, pageSize, data) {
  return request.post(`/supplies/list/${pageIndex}/${pageSize}`, data)
}

function saveSupply(data) {
  return request.post('/supplies/create', data)
}

function updateSupply(data) {
  return request.post('/supplies/update', data)
}

function deleteSupply(data) {
  return request.get('/supplies/delete/' + data.id)
}

function createRequest(data) {
  return request.post('/requests/create', data)
}

function fetchRequests(pageIndex, pageSize, data) {
  return request.post(`/requests/list/${pageIndex}/${pageSize}`, data)
}

function cancelRequest(data) {
  return request.get(`/requests/cancel/${data.id}`)
}

function reviewRequest(data) {
  return request.get(`/requests/apply/${data.id}`)
}

function rejectRequest(data) {
  return request.post('/requests/reject', data)
}

function fetchWarnings(params) {
  return request.get('/replenishment/warnings', { params })
}

function createReplenishment(data) {
  return request.post('/replenishment/create', data)
}

function fetchReplenishments(pageIndex, pageSize, data) {
  return request.post(`/replenishment/list/${pageIndex}/${pageSize}`, data)
}

function processReplenishment(data) {
  return request.post('/replenishment/apply', data)
}

function rejectReplenishment(data) {
  return request.post('/replenishment/reject', data)
}

function fetchNotifications(pageIndex, pageSize, data) {
  return request.post(`/notification/list/${pageIndex}/${pageSize}`, data)
}

function fetchNotificationUnreadCount() {
  return request.get('/notification/unread/count')
}

function markNotificationRead(data) {
  return request.get(`/notification/mark/read/${data.id}`)
}

function markAllNotificationsRead() {
  return request.get('/notification/mark/all')
}

function updateProfile(data) {
  return request.post('/user/update', data)
}

function fetchEmployees(pageIndex, pageSize, data) {
  return request.post(`/user/list/${pageIndex}/${pageSize}`, data)
}

function createEmployee(data) {
  return request.post('/user/create', data)
}

function banEmployee(userId) {
  return request.get(`/user/ban/${userId}`)
}

function enableEmployee(userId) {
  return request.get(`/user/enable/${userId}`)
}

function fetchDashboard() {
  return request.get('/dashboard/info')
}

export {
  banEmployee,
  cancelRequest,
  createEmployee,
  createReplenishment,
  createRequest,
  deleteSupply,
  enableEmployee,
  fetchDashboard,
  fetchEmployees,
  fetchNotificationUnreadCount,
  fetchNotifications,
  fetchReplenishments,
  fetchRequests,
  fetchSupplies,
  fetchWarnings,
  getCaptcha,
  login,
  markAllNotificationsRead,
  markNotificationRead,
  processReplenishment,
  rejectReplenishment,
  register,
  rejectRequest,
  reviewRequest,
  saveSupply,
  updateSupply,
  updateProfile
}
